import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import { layoutRouter, staticRouter, errorRouter } from "@/routers/modules/staticRouter";
import nprogress from "@/utils/nprogress";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import useUserStore from "@/stores/modules/user";
import useAuthStore from "@/stores/modules/auth";
import { HOME_URL, LOGIN_URL, ROUTER_WHITE_LIST } from "@/config/index";
import { initApiMenuRouter } from "@/routers/modules/dynamicRouter";
import { lcMsgWarning } from "@/utils/util";

// .env配置文件读取
const mode = import.meta.env.VITE_ROUTER_MODE;

// 路由访问两种模式：带#号的哈希模式，正常路径的web模式
const routerMode: any = {
  hash: () => createWebHashHistory(),
  history: () => createWebHistory(),
};

// 创建路由器对象
const router = createRouter({
  // 路由模式hash或者默认不带#
  history: routerMode[mode](),
  routes: [...layoutRouter, ...staticRouter, ...errorRouter],
  strict: false,
  // 滚动行为
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

/**
 * @description 前置路由
 * */
router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  // console.log("前置守卫", to, from);
  const userStore = useUserStore();
  const authStore = useAuthStore();

  nprogress.start();

  const title = import.meta.env.VITE_WEB_TITLE;
  document.title = title;

  // 判断是访问登陆页，有Token访问当前页面，token过期访问接口，axios封装则自动跳转登录页面，没有Token重置路由到登陆页
  const loginWhiteList = ["/", HOME_URL, LOGIN_URL, "/cloudArchive"];
  if (loginWhiteList.indexOf(to.path.toLocaleLowerCase()) !== -1) {
    // 有Token访问当前页面
    // if (userStore.token) {
    //   return next(from.fullPath);
    // } else {
    //   lcMsgWarning("登录状态已过期，请重新登录");
    // }
    // // 没有Token重置路由到登陆页
    // resetRouter();
    return next();
  }

  // 如果是直接请求白名单的路由则不获取菜单
  const whiteList = staticRouter.map((item) => item.path);
  if (whiteList.indexOf(to.path) !== -1) {
    return next();
  }

  // 判断访问页面是否在路由白名单地址[静态路由]中，如果存在直接放行
  if (ROUTER_WHITE_LIST.includes(to.path)) {
    return next();
  }

  // 判断是否有 Token，没有重定向到 login 页面。
  if (!userStore.token) {
    return next({ path: LOGIN_URL, replace: true });
  }

  // 正常访问页面
  next();
});

/**
 * @description 重置路由
 */
export const resetRouter = () => {
  const authStore = useAuthStore();
  authStore.getMenuList.forEach((route: any) => {
    const { name } = route;
    if (name && router.hasRoute(name)) {
      router.removeRoute(name);
    }
  });
};

/**
 * @description 路由跳转错误
 */
router.onError((error) => {
  // 结束全屏动画
  nprogress.done();
  console.warn("路由错误", error);
});

/**
 * @description 后置路由
 */
router.afterEach((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  // 结束全屏动画
  nprogress.done();
});

export default router;
